import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BooleanCons, NumberCons, StringConst } from 'src/app/constants/const';
import { IProducts } from 'src/app/model/http/myActivity.model';
import { ActivesPrinciplesValidation } from 'src/app/model/local/active.missing';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-no-available-item-message',
  templateUrl: './no-available-item-message.component.html',
  styleUrls: ['./no-available-item-message.component.scss']
})
export class NoAvailableItemMessageComponent implements OnInit, OnChanges {
  @Input() product = new IProducts();
  @Input() isProductMessage = BooleanCons.true;
  @Input() attributeIndex = NumberCons.zero;
  @Input() isInvalidFromProduct = BooleanCons.false;
  hasMissingPrinciplesActives = BooleanCons.false;
  fullMissingPrinciplesActives = StringConst.empty;
  missingPrinciplesActives = StringConst.empty;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getmissingPrinciplesActives();
  }

  getmissingPrinciplesActives(): void {
    if (this.product.missingPrinciplesActives?.length > 0) {
      this.hasMissingPrinciplesActives = true;
      this.missingPrinciplesActives = this.product.missingPrinciplesActives.join(', ');
      this.fullMissingPrinciplesActives = this.missingPrinciplesActives;
      if (this.missingPrinciplesActives.length > 50) {
        this.missingPrinciplesActives = this.missingPrinciplesActives.substring(0, 40);
        this.missingPrinciplesActives = this.missingPrinciplesActives + '...';
        return;
      }
      return;
    }
    this.hasMissingPrinciplesActives = false;
  }

}
